import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'app-fileupload',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './fileupload.component.html',
    styleUrl: './fileupload.component.css',
})
export class FileUploadComponent {
    @ViewChild('fileInput') private fileInput?: ElementRef<HTMLInputElement>;

    @Input() accept: string | null = null;
    @Input() multiple = false;
    @Input() disabled = false;
    @Input() id = 'file-upload';
    @Input() name = 'file-upload';

    @Output('fileChange') filesSelected = new EventEmitter<File[]>();

    selectedFileNames: string[] = [];

    onFileChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        const files = input.files ? Array.from(input.files) : [];
        this.selectedFileNames = files.map(file => file.name);
        this.filesSelected.emit(files);
    }

    clearSelection(): void {
        this.selectedFileNames = [];

        if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
        }
    }
}
